import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './ListingPage.module.css';

const { Money } = sdkTypes;

const SectionDepositMaybe = props => {
  const { listing, intl } = props;

  if (!listing?.attributes?.publicData) {
    return null;
  }

  const { publicData } = listing.attributes;
  const depositAmount = publicData.depositAmount;

  if (!depositAmount || !depositAmount.amount) {
    return null;
  }

  const depositMoney = new Money(depositAmount.amount, depositAmount.currency);
  const formattedDeposit = formatMoney(intl, depositMoney);

  return (
    <div className={css.sectionDeposit}>
      <div className={css.depositRow}>
        <span className={css.depositLabel}>
          <FormattedMessage id="ListingPage.depositRequired" values={{ depositAmount: formattedDeposit }} />
        </span>
      </div>
      <p className={css.depositNote}>
        <FormattedMessage id="ListingPage.depositNote" />
      </p>
    </div>
  );
};

export default SectionDepositMaybe;
